import authorizationDictionary from '../../ru/authorization/authorization.dic.json';

export const authNS = {
  AUTH: authorizationDictionary,
};

export const authNamespaces = ['AUTH'];
